import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import * as fromModels from '@models';
import { Store } from '@ngrx/store';
import { RootState } from '@base/rootReducers';
import * as etlActions from '@etl/etl.actions';
import * as etlSelectors from '@etl/etl.selectors';
import { MatDialog, MatSnackBar } from '@angular/material';
import { IDialogData } from '@base/interfaces';
import { DialogEtlComponent } from '@etl/dialog/dialog.component';
import { DialogComponent } from '@base/dialog/dialog.component';
import { faThumbsUp, faThumbsDown } from '@fortawesome/free-regular-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import * as fromUtils from '@utils';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-job-card',
  templateUrl: './job-card.component.html',
  styleUrls: ['./job-card.component.sass']
})
export class JobCardComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  startingJob = false;
  jobOk = faThumbsUp;
  jobError = faThumbsDown;
  faSpinner = faSpinner;
  ROLES = fromUtils.ROLES;
  @Input() job: fromModels.Etl;

  constructor(
    private store: Store<RootState>,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router,
  ) { }

  ngOnInit() {
    const actionStarted = this.store.select(etlSelectors.actionStarted).subscribe(
      (success: boolean) => {
        if (success) {
          this.startingJob = false;
          this.openSnackBar('El Job ha sido iniciado', 'ETL');
        }
      }
    );

    const errorSubs = this.store.select(etlSelectors.getError).subscribe(
      ({error, errorType}) => {
        if (error !== null) {
          // let message = '';
          this.startingJob = false;

          // if (errorType === fromPar.errorTypes.fetching) {
          //   message = 'No se pudo obtener los datos';
          // } else if (errorType === fromEtl.errorTypes.startingJob) {
          //   message = 'No se pudo iniciar el Job';
          // }
          // this.openSnackBar(error.message, 'info');
        }
      }
    );

    this.subscriptions = [...this.subscriptions, actionStarted, ];
  }

  ngOnDestroy() {
    this.subscriptions.map((subscription) => subscription.unsubscribe());
  }

  openPopup(etl: fromModels.Etl) {
    if (!this.startingJob) {
      this.store.dispatch(etlActions.setRow({row: etl}));
      const params = {
        title: 'Editar Enlace',
      };
      const dialogRef = this.dialog.open(DialogEtlComponent, {
        width: '350px',
        data: params,
        disableClose: true,
      });
    }
  }

  deleteLink(etl: fromModels.Etl) {
    if (!this.startingJob) {
      const params: IDialogData = {
        strQuestion: `¿Confirma eliminar el enlace ${etl.name}?`,
        strAccept: 'Aceptar',
        strCancel: 'Cancelar',
        buttonColor: 'warn',
      };
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '370px',
        data: params,
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe((deleted: boolean) => {
        if (deleted) {
          const payload = {row: etl};
          this.store.dispatch(etlActions.remove(payload));
        }
      });
    }
  }

  private openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 4000,
    });
  }

  triggerAction(etl: fromModels.Etl) {
    const params: IDialogData = {
      strQuestion: `¿Confirma que desea ejecutar <strong>${etl.name}</strong>?`,
      strAccept: 'Ejecutar',
      strCancel: 'Cancelar',
      buttonColor: 'primary',
    };
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '370px',
      data: params,
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe(startJob => {
      if (startJob) {
        this.startingJob = true;
        this.store.dispatch(etlActions.startAction({row: etl}));
      }
    });
  }

  showJobDetails(etl: fromModels.Etl) {
    // this.store.dispatch(etlActions.jobDetails({row: etl}));
    this.router.navigate([`${this.router.url}/job`, etl.id]);
  }
}
